import styled from 'styled-components';
import { animated } from 'react-spring';

export const Container = styled(animated.div)`
  
`;

export const Image = styled.img`
`;
